import styled from 'styled-components';
import { TypographyStyles, spacing } from '../../../stylings';

export const DeliveryDays = styled.span`
  ${TypographyStyles.Body.Tiny.Regular}
  display: block;
  margin: 0;
`;

export const DeliveryItem = styled.span`
  ${TypographyStyles.Body.Small.SemiBold}
`;

export const DeliveryName = styled.span`
  ${TypographyStyles.Body.Small.Regular}
`;

export const DeliveryOptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: ${spacing.XS} 0;
  padding: 0;
`;

export const NoDeliveryOptions = styled.span`
  display: block;
  margin: ${spacing.XXXS} 0;
`;
